import React from 'react';

export const Cover = React.lazy(() => import('./Cover'));
